<div class="tag-input-container" appClickOutside (appClickOutside)="onClickOutside($event)">

  <!-- Tags display + add trigger -->
  <div class="tags-and-input-wrapper" [ngClass]="{'bg-pure-white': isMobile}">
    <div
      *ngFor="let tagItem of tags; let i = index"
      class="rounded-8 border d-flex bg-gray-100 text-gray-700 border-gray-300 mr-2"
      [ngClass]="{'editing': editingIndex === i}">
      <span
        class="tag-text f-size-12 font-weight-medium pl-2"
        (click)="editTag(i)">
        {{ tagItem.value }}
      </span>
      <button
        type="button"
        class="remove-tag-btn"
        (click)="removeTag(i, $event)">
        <ibm-icon-close size="16" class="icon-14 fill-medium"></ibm-icon-close>
      </button>
    </div>

    <!-- Add tag trigger -->
    <button type="button" (click)="showInput()" class="add-tag-btn">
      <ibm-icon-add size="16" class="fill-medium pb-02"></ibm-icon-add>
      <span *ngIf="!tags || tags.length === 0" class="ml-1 mr-1">Tag</span>
    </button>
  </div>

  <!-- Dropdown panel -->
  <div
    *ngIf="isDropdownOpen"
    class="tag-suggestions-dropdown"
    style="padding: 0;">

    <!-- Search input -->
    <div style="border-bottom: 1px solid #f3f4f6;">
      <div style="display: flex; align-items: center; gap: 8px; background: #ffffff; border: 1px solid #e5e7eb; border-radius: 6px; padding: 6px 10px; margin: 12px 10px 8px 10px;">
        <lucide-icon name="search" [size]="14" style="color: #9ca3af; flex-shrink: 0;"></lucide-icon>
        <input
          #inputElement
          type="text"
          [value]="inputValue"
          (input)="handleInputChange($event)"
          (keydown)="handleInputKeyDown($event)"
          (focus)="handleInputFocus()"
          (blur)="handleInputBlur()"
          placeholder="Search tags..."
          style="border: none; outline: none; background: #ffffff; font-size: 13px; color: #111827; width: 100%;"
          (click)="$event.stopPropagation()"
        />
      </div>
    </div>

    <!-- Tag suggestions list -->
    <div style="max-height: 220px; overflow-y: auto;">
      <div *ngIf="filteredSuggestions.length === 0" style="padding: 10px 14px; font-size: 13px; color: #9ca3af;">
        No tags found
      </div>
      <div
        *ngFor="let suggestion of filteredSuggestions"
        style="padding: 8px 14px; cursor: pointer; display: flex; align-items: center; gap: 10px;"
        (mouseenter)="$event.currentTarget.style.backgroundColor = '#e5e7eb'"
        (mouseleave)="$event.currentTarget.style.backgroundColor = 'transparent'"
        (mousedown)="$event.preventDefault()"
        (click)="selectSuggestion(suggestion)">
        <lucide-icon name="hash" [size]="14" style="color: #9ca3af; flex-shrink: 0;"></lucide-icon>
        <span style="font-size: 13px; color: #111827;">{{ suggestion.value }}</span>
      </div>
    </div>

  </div>
</div>
